// extracted by mini-css-extract-plugin
export default {"feauture-comparison-table":"FeatureComparisonTable_feauture-comparison-table__b3DSM"};